export default __webpack_public_path__ + "static/our-team-icon-be262d2ed8a6f2401f0883077187e0fe.png";